export const studentventures = [
                {
                title: "Ellie Grace",
                desc: "Sustainable handmade clothing and accessories brand rooted in timelessness, elegance, and femininity.",
                img: "studentbusinesses/EllieGrace.png",
                link: "https://www.instagram.com/elliegrace.co/"
                },
                {
                title: "Oatful",
                desc: "UAE's first overnight oats mix packed with 20g+ of protein, superfoods, and fiber. Soon will be introducing the world's first high protein ready-to-eat overnight oats.",
                img: "studentbusinesses/Oatful.png",
                link: "https://shopoatful.com/"
                },
                {
                title: "Discount City Fireworks",
                desc: "Fireworks business with over $120,000 worth of inventory based in Lubbock, Texas.",
                img: "studentbusinesses/DiscountCityFireworks.png",
                link: "https://discount-city-fireworks.business.site/"
                },
                {
                title: "Afritrip Advisors",
                desc: "A travel concierge offering private personalized and customizable trips to Morroco. Afritrip planes on expanding trips into the rest of Africa in the near future.",
                img: "studentbusinesses/AfritripAdvisors.png",
                link: "https://www.afritripmorocco.com/"
                }
            ]